import PropTypes from "prop-types";
import MuiLink from "@mui/material/Link";
import Grid2 from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MKBox from "../../../components/MKBox";
import MKTypography from "../../../components/MKTypography";
import colors from "../../../assets/theme/base/colors";
import borders from "../../../assets/theme/base/borders";
import convertToValidHttps from "../../../utils/convertToValidHttps";

const { grey } = colors;

const CollectionCard = ({ collection, linkPrefix }) => {
  const link = linkPrefix + collection.id;
  const { summaries, title } = collection;
  const { info } = collection.summaries;
  let infoList = [];

  let thumb = "";

  if (linkPrefix === "/data-map/") {
    infoList = [
      "organization",
      "author",
      "region",
      "resolution",
      "category",
      "year",
      "geographic extent",
    ];
    thumb = convertToValidHttps(summaries.paths.abs_path + summaries.paths.thumbnail_rel_path);
  } else if (linkPrefix === "/analysis/") {
    infoList = ["category", "year"];
    thumb = summaries.thumbnail;
  }
  const dataSource =
    linkPrefix === "/analysis/" ? (
      <MKBox sx={{ display: "block", width: 1 }}>
        <MKBox sx={{ display: "inline-block", pr: 3 }}>
          <MKTypography
            variant="body2"
            fontWeight="bold"
            textTransform="capitalize"
            sx={{
              display: "inline",
            }}
          >
            Data Source
            <ArrowForwardIcon />
          </MKTypography>
          <MuiLink href={`/data-map/${summaries.source}`} target="_self" rel="noreferrer">
            <MKTypography
              variant="body2"
              color="text"
              sx={{
                display: "inline",
                textDecoration: "underline",
                "&:hover": {
                  fontWeight: "bold",
                  color: "secondary.focus",
                },
              }}
            >
              {summaries.source_title}
            </MKTypography>
          </MuiLink>
        </MKBox>
      </MKBox>
    ) : null;

  return (
    <MKBox
      sx={{
        bgcolor: "white",
        borderRadius: borders.borderRadius.xl,
        borderColor: ({ palette: { primary }, functions: { rgba } }) =>
          `${rgba(primary.main, 0.2)}`,
        my: 5,
      }}
    >
      <Grid2 container sx={{ height: 1 }}>
        <Grid2 xs={3} sx={{ p: 1, display: { xs: "none", lg: "flex" } }}>
          <MKBox
            component="img"
            src={thumb}
            alt={title}
            title={title}
            sx={{
              borderColor: grey[400],
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              objectFit: "contain",
              overflow: "hidden",
              height: 1,
              borderRadius: 0,
              maxHeight: linkPrefix === "/analysis/" ? "160px" : "200px",
              width: 1,
            }}
          />
        </Grid2>
        <Grid2 xs={12} lg={9} sx={{ p: 1 }}>
          <Stack direction="column" justifyContent="space-between" height={1}>
            <MuiLink href={link} target="_self" rel="noreferrer">
              <MKTypography
                variant="subtitle1"
                fontWeight="medium"
                gutterBottom
                color="primary"
                sx={{
                  display: "block",
                  "&:hover": {
                    color: "primary.focus",
                  },
                }}
              >
                {title}
              </MKTypography>
            </MuiLink>
            <MKTypography
              variant="body2"
              color="text"
              title={collection.description}
              sx={{
                width: 1,
                textOverflow: "ellipsis",
                overflow: "hidden",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: { md: "4", lg: "2", xxl: "3", xxxl: "4" },
              }}
            >
              {collection.description}
            </MKTypography>
            <MKBox sx={{ display: "block", width: 1 }}>
              {infoList.map((item) => (
                <MKBox key={item} sx={{ display: "inline-block", pr: 3 }}>
                  <MKBox sx={{ display: "flex", alignItems: "center" }}>
                    <MKBox sx={{ display: "inline" }}>
                      <MKTypography
                        variant="body2"
                        fontWeight="bold"
                        textTransform="capitalize"
                        sx={{ display: "inline" }}
                      >
                        {`${item}:`}
                      </MKTypography>
                    </MKBox>
                    <MKTypography
                      variant="body2"
                      color="text"
                      sx={{ flexWrap: "wrap", display: "inline", marginLeft: 1 }}
                    >
                      {info[item].replace(/~/g, " - ").replace(/,/g, " , ")}
                    </MKTypography>
                  </MKBox>
                </MKBox>
              ))}
            </MKBox>
            {dataSource}
          </Stack>
        </Grid2>
      </Grid2>
    </MKBox>
  );
};

CollectionCard.propTypes = {
  linkPrefix: PropTypes.string.isRequired,
  collection: PropTypes.oneOfType([PropTypes.any]).isRequired,
};

export default CollectionCard;
